import { Icon } from '@components/index';

interface SandboxSwitchProps {
  isProfileList: boolean;
}

const SandboxSwitch = ({ isProfileList }: SandboxSwitchProps) => {
  const isSandBoxEnv = process.env.REACT_APP_ENVIRONMENT === 'sandbox';

  const onClickSwtichEnv = () => {
    if (isSandBoxEnv) window.open('https://web.cofee.life/', '_blank');
    else window.open('https://web.sandbox.cofee.life/', '_blank');
  };

  return (
    <div
      className={`flex cursor-pointer items-center gap-2 rounded-md text-sm ${
        isProfileList
          ? 'py-2 text-content hover:bg-grey1'
          : 'py-2 text-white hover:bg-darkGrey'
      }`}
      onClick={onClickSwtichEnv}
      role="presentation"
    >
      <Icon
        name="link"
        size="none"
        className={`size-4.5 ${isProfileList ? 'text-grey4' : 'text-white'}`}
      />
      <div>{isSandBoxEnv ? 'Production' : 'Sandbox'}</div>
    </div>
  );
};

export default SandboxSwitch;
